import { PartiesSidebar } from "@/components/PartiesSidebar";
import { Outlet, createFileRoute } from "@tanstack/react-router";

type PartiesSearch = {
	role?: string;
	q?: string;
};

export const Route = createFileRoute("/parties")({
	validateSearch: (search: Record<string, unknown>): PartiesSearch => ({
		role: typeof search.role === "string" ? search.role : undefined,
		q: typeof search.q === "string" ? search.q : undefined,
	}),
	component: PartiesLayout,
});

function PartiesLayout() {
	return (
		<div className="flex h-full overflow-hidden">
			<PartiesSidebar />
			<div className="flex-1 overflow-hidden">
				<Outlet />
			</div>
		</div>
	);
}
